import { useMemo } from "react";

// apply persistence config on atom state
function useApplyAtomPersistence({ pageProps = {}, store }:any) {

  // run only once in sync
  useMemo(() => {
    // initialize atom store
    if('applyAtomPersistence' in pageProps) {
      pageProps.applyAtomPersistence(store);
    }
  }, [pageProps.applyAtomPersistence]);

}

export default useApplyAtomPersistence;
